export default __webpack_public_path__ + "static/media/icon-bank-black.e94bdc23.svg";